import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconAtom({ srText, size = 'md', className = '', ...props }: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='atom_svg__a'>
            <path d='M1.395.707H23.98v22.586H1.395Zm0 0' />
          </clipPath>
        </defs>
        <g
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path
            strokeWidth={1.41176}
            d='M12.695 14.125a2.117 2.117 0 1 0 0-4.234 2.116 2.116 0 1 0 0 4.234m0 0'
          />
          <g clipPath='url(#atom_svg__a)'>
            <path
              strokeWidth={1.41176}
              d='M16.191 15.5C21.703 9.988 24.61 3.953 22.68 2.023 20.75.093 14.715 3 9.203 8.512 3.688 14.027.785 20.062 2.715 21.988c1.926 1.934 7.96-.972 13.476-6.488m0 0'
            />
            <path
              strokeWidth={1.41176}
              d='M22.68 21.992c1.93-1.93-.977-7.965-6.489-13.476C10.676 3 4.641.098 2.715 2.027c-1.93 1.93.973 7.961 6.488 13.477 5.512 5.512 11.547 8.418 13.477 6.488m0 0'
            />
          </g>
        </g>
      </svg>
    </>
  )
}
IconAtom.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconAtom
